module.exports = __webpack_public_path__ + "static/tyrant01-sq-f6dba8997cbc3eec18203d0451c401c5.png";